import anime from 'animejs';
let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);

// Show an element
var show = function(elem) {
    toggleActive(true);

    document.body.style.overflow = 'hidden';

    anime({
        targets    : elem,
        translateX : -1000,
        easing     : 'easeInOutQuad',
        duration   : 350
    });

    if (isSafari) {
        setTimeout(function() {
            elem.setAttribute('style', 'right: -1000px; -webkit-transform: translateX(-1000px);');
        }, 400)
    }
};

// Hide an element
var hide = function(elem) {
    toggleActive(false);

    document.body.style.overflow = 'auto';

    anime({
        targets    : elem,
        translateX : 1000,
        easing     : 'easeInOutQuad',
        duration   : 350
    });

    if (isSafari) {
        setTimeout(function() {
            elem.setAttribute('style', 'right: -1000px; -webkit-transform: translateX(1000px);');
        }, 400)
    }
};

var toggleActive = function(direction) {
    let app = document.getElementById("app");

    if (direction) {
        app.classList.add('dark-overlay');

        setTimeout(function() {
            app.classList.add('active');
        }, 10);
    } else {
        app.classList.remove('active');

        setTimeout(function() {
            app.classList.remove('dark-overlay');
        }, 350);
    }
};

function waitForMenuElementToDisplay(menu, time)
{
    if (menu != null && window.location.pathname !== '/cart/payment') {
        let close = document.getElementById('cart-close');
        let icon  = document.getElementById('cart-icon');

        // Listen for click events
        if (icon) {
            icon.addEventListener('click', function (event) {
                // Prevent default link behavior
                event.preventDefault();

                // Toggle the content
                show(menu);

            }, false);
        }

        // Listen for click events
        if (close) {
            close.addEventListener('click', function (event) {
                // Prevent default link behavior
                event.preventDefault();

                // Toggle the content
                hide(menu);

            }, false);
        }

        // Always close on Escape key
        document.onkeydown = function(evt) {
            evt          = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key == "Escape" || evt.key == "Esc");
            } else {
                isEscape = (evt.keyCode == 27);
            }
            if (isEscape) {
                hide(menu);
            }
        };

        // Customer event to open the menu
        window.addEventListener('cart-open', function(e) {
            show(menu);
        }, false);

        // Close if open and click not on element
        window.addEventListener('click', function(e) {
            if (menu && !menu.contains(e.target) && icon && !icon.contains(e.target)) {
                if (window.getComputedStyle(menu).transform === "matrix(1, 0, 0, 1, -1000, 0)") {
                    hide(menu);
                    return;
                }
            }
        });
    } else {
        setTimeout(function() {
            waitForMenuElementToDisplay(document.getElementById('cart-menu'), time);
        }, time);
    }
}

window.addEventListener('load', function() {
    waitForMenuElementToDisplay(document.getElementById('cart-menu'), 200);
});
